import useMutation from 'api/hooks/useMutation';
import useTrackWithUser from 'api/hooks/useTrackWithUser';
import permission from 'api/Apollo/permissions';
import { GET_ALL_EVENT_NAMES } from 'api/event-names/all-event-names-query-builder';
import { GET_EVENT_NAMES } from 'api/event-names/event-names-query-builder';

import {
  mutation as updateEventNameMutation,
  buildVariables as buildUpdateEventNameVariables,
} from './update-event-name-mutation-builder';

export default function useUpdateEventName(options = {}) {
  const [trackWithUser] = useTrackWithUser('event_name_updated');
  const [executeMutation, response] = useMutation(updateEventNameMutation, {
    ...options,
    refetchQueries: [{ query: GET_ALL_EVENT_NAMES }, GET_EVENT_NAMES],
    context: { permission: permission.updateEventNames },
  });

  const updateEventName = async ({ id, name, description }) => {
    const response = await executeMutation({
      variables: buildUpdateEventNameVariables({ id, name, description }),
    });

    if (!response.errors) {
      trackWithUser();
    }

    return response;
  };

  return [updateEventName, response];
}
